(() => {
  const tagName = 'cc-t10-music-available';
  const mobileQuery = '(max-width: 768px)';

  if (customElements.get(tagName)) return;

  class CcT10MusicAvailable extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.mobileMedia = window.matchMedia(mobileQuery);
      this.activeButton = null;

      this.addEventListener('click', this.handleSectionClick, { signal: this.controller.signal });
      document.addEventListener('click', this.handleDocumentClick, { signal: this.controller.signal });
      this.mobileMedia.addEventListener('change', this.handleBreakpointChange, { signal: this.controller.signal });
      this.syncBreakpoint();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.activeButton = null;
    }

    handleSectionClick = (event) => {
      if (!this.mobileMedia.matches) return;
      const button = event.target.closest('[data-cc-t10-music-service]');
      if (!button || !this.contains(button)) return;
      if (button === this.activeButton) return;
      this.setActive(button);
    };

    handleDocumentClick = (event) => {
      if (!this.mobileMedia.matches || !this.activeButton) return;
      const button = event.target.closest?.('[data-cc-t10-music-service]');
      if (button && this.contains(button)) return;
      this.resetActive();
    };

    handleBreakpointChange = () => this.syncBreakpoint();

    syncBreakpoint() {
      if (!this.mobileMedia.matches) this.resetActive();
    }

    setActive(button) {
      if (this.activeButton) this.deactivate(this.activeButton);
      this.activeButton = button;
      button.classList.add('is-cc-active');
      button.setAttribute('aria-pressed', 'true');
      const description = button.querySelector('.cc-t10-music-available__description-layer');
      description.setAttribute('aria-hidden', 'false');
      button.setAttribute('aria-describedby', description.id);
    }

    deactivate(button) {
      button.classList.remove('is-cc-active');
      button.setAttribute('aria-pressed', 'false');
      button.querySelector('.cc-t10-music-available__description-layer').setAttribute('aria-hidden', 'true');
      button.removeAttribute('aria-describedby');
    }

    resetActive() {
      if (!this.activeButton) return;
      this.deactivate(this.activeButton);
      this.activeButton = null;
    }
  }

  customElements.define(tagName, CcT10MusicAvailable);
})();
